import { AxiosResponse } from 'axios';
import axiosApi from '../api/axios-api';

export default {
	companyReportSheetUpdate(request: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheet/` + templateIndex + `/update`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportSheetUpdateCached(request: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheet/` + templateIndex + `/update/cached`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportSheetDeleteCached(request: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheet/` + templateIndex + `/delete/cached`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
	companyReportSheetViewByCompanyReportId(id: any, sheetType: any, templateIndex: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheet/` + templateIndex + `/view/companyreport/` + sheetType + `/` + id, null)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
};
